import { render } from "./AltelBanner.vue?vue&type=template&id=a88d7260&scoped=true&ts=true"
import script from "./AltelBanner.vue?vue&type=script&lang=ts"
export * from "./AltelBanner.vue?vue&type=script&lang=ts"

import "./AltelBanner.vue?vue&type=style&index=0&id=a88d7260&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88d7260"]])

export default __exports__